module.exports = __webpack_public_path__ + "static/media/creative-logo.4f4c5337.svg";